enum JobPremission {
  CreateJob = 'CreateJob',
}

export default JobPremission;
